'use client';
import GloLayout from 'lowcode/common/GloLayout';
import './index.scss';
export default function Content({ id, data = {}, attr = {} }: any) {
    const list = data.list || []; //列

    return (
        <GloLayout className={`blog-text-table`} id={id}>
            <table>
                <thead>
                    <tr>
                        {list?.map((column: any, colIndex: number) => (
                            <th key={colIndex}>{column.name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {list?.[0]?.cells?.map((_: any, rowIndex: number) => (
                        <tr key={`${rowIndex}`}>
                            {list?.map((column: any, colIndex: number) => (
                                <td key={`${colIndex}-${rowIndex}`}>{column.cells[rowIndex]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </GloLayout>
    );
}
